var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotagAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1658 16C11.2198 16.0009 10.2825 15.8279 9.40595 15.4905C9.82343 15.2921 10.21 15.0399 10.5547 14.7412C10.8977 14.4441 11.1954 14.1033 11.4393 13.7285C11.9449 12.9531 12.1968 12.0531 12.1632 11.1421C12.1316 10.2718 11.8456 9.42687 11.337 8.70175C10.8284 7.97663 10.1173 7.39983 9.28301 7.03573L9.28147 7.03451L9.28084 7.0327L9.28131 7.03084L9.28274 7.02949C9.86038 6.69633 10.3402 6.2305 10.6778 5.67503C10.9947 5.15179 11.1752 4.56426 11.204 3.96145C11.2328 3.35864 11.1092 2.75804 10.8435 2.20974C11.7704 2.05012 12.7209 2.0597 13.644 2.23797C14.5821 2.42006 15.4733 2.77548 16.2666 3.28396C17.4457 4.03834 18.3687 5.10078 18.9238 6.34255C19.1113 6.76307 19.2544 7.20016 19.351 7.64743C19.5497 8.57194 19.5497 9.52494 19.351 10.4495C19.1588 11.3387 18.7838 12.1834 18.2474 12.9352C17.4512 14.0529 16.3303 14.9278 15.0205 15.4537C14.5769 15.6315 14.1158 15.7672 13.644 15.8589C13.1575 15.9528 12.6623 16.0001 12.1658 16ZM7.13284 16H0.504001L0.502496 15.9998L0.501204 15.999L0.500326 15.9978L0.5 15.9964V6.36294C0.499895 5.93249 0.545581 5.50314 0.636365 5.0814C0.812167 4.26793 1.15524 3.49527 1.64598 2.80755C2.37431 1.78508 3.39967 0.984813 4.59786 0.503677C5.00364 0.341078 5.42538 0.216949 5.85694 0.133105C6.30206 0.0470771 6.75519 0.00379771 7.20947 0.00392242V0C7.97452 0.000537863 8.72339 0.208967 9.3674 0.600604C10.0114 0.992242 10.5238 1.55062 10.8435 2.20974C9.58775 2.4273 8.41363 2.95275 7.43832 3.73376C6.79847 4.24532 6.25523 4.85653 5.83192 5.54115C5.30255 6.40211 4.97441 7.36086 4.86972 8.35252C4.76502 9.34418 4.88622 10.3456 5.22509 11.289C5.56397 12.2324 6.11262 13.0957 6.83391 13.8205C7.5552 14.5454 8.43242 15.115 9.40595 15.4905C8.70054 15.8261 7.92202 16.0005 7.13284 16Z",
    fill: "url(#paint0_linear_4161_11263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4161_11263",
    x1: 21.0285,
    y1: -5.6,
    x2: 2.65382,
    y2: 27.2056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotagAiIcon);
export default __webpack_public_path__ + "static/media/BotagAIIcon.56cca9f4a027f9f9452e3db8d66f018d.svg";
export { ForwardRef as ReactComponent };